import { DSL_MAX_LENGTH } from './constants';

const NEWLINE_LIKE = /[\t\n\r\v\f]+/g;
const CONTROL_CHARS = /[\x00-\x08\x0E-\x1F\x7F-\x9F]/g;
// Zero-width spaces/joiners (U+200B-200D), bidi marks/embeddings/overrides (U+200E-200F, U+202A-202E),
// bidi isolates (U+2066-2069), and the BOM (U+FEFF) - invisible characters with no legitimate use in
// a search query, and a known vector ("Trojan Source") for visually spoofing displayed text.
const INVISIBLE_FORMATTING = /[\u200B-\u200F\u202A-\u202E\u2066-\u2069\uFEFF]/g;

/**
 * Strips characters that have no legitimate place in this single-line search expression before it
 * ever reaches the parser/state: ASCII/Latin-1 control characters and invisible Unicode formatting
 * characters. Newline-like whitespace collapses to a single space rather than being dropped
 * outright, so words on either side don't get glued together. Also hard-caps length as defense in
 * depth beyond the input's `maxLength` attribute, which client-side state can bypass.
 */
export const sanitizeDslInput = (raw: string): string => {
    const cleaned = raw
        .replace(NEWLINE_LIKE, ' ')
        .replace(CONTROL_CHARS, '')
        .replace(INVISIBLE_FORMATTING, '');
    return cleaned.slice(0, DSL_MAX_LENGTH);
};
